<div>
    <ng-template #clobViewPopup>
        <button class="close close-button" (click)="closeHtmlContent()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
      
        <div mat-dialog-title>
          <label for="title" class="popupTitle"> {{title}}</label>
          <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
   
                <div class="row myTrainingLeftPlace" style="height: auto;max-height: 500px;overflow-y: auto;overflow-x: hidden;">
                    <div class="col-sm-12"><st-editor [(ngModel)]="htmlContent" [config]="config" 
                        [spellcheck]="true" ></st-editor></div>
                </div>
                
    </ng-template>
</div>
